<template>
  <div class="input-wrapper">
    <label
      :for="inputData.name"
      v-if="data.Text && useLabel"
      :title="data.Text"
      >{{ data.Text }}</label
    >
    <input
      :id="inputData.name"
      :name="inputData.name"
      :required="inputData.required"
      type="text"
      :placeholder="data.Text && !useLabel ? data.Text : 'mm/dd/yyyy'"
      class="input-date"
      v-model="inputVal"
      @keydown="onKeyDown"
      @keyup="onType"
      @focus="onFocus"
      @blur="onBlur"
      maxlength="10"
      pattern="[0-9]{2}\/[0-9]{2}\/[0-9]{4}"
    />
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'
import { DateTime } from 'luxon'

export default {
  name: 'InputDate',
  components: {},
  props: {
    value: String,
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
    useLabel: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      isFocused: false,
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      }
    }
  },
  computed: {
    inputVal: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal

      var dt = DateTime.fromFormat(this.inputVal, 'LL/dd/yyyy')
      if (dt.isValid) {
        this.$emit('input:value-parsed', dt.toFormat('LL/dd/yyyy'))
        this.$emit('input:isvalid', true)
        this.$emit('input', dt.toFormat('LL/dd/yyyy'))
      }
      else if (this.data.Required || this.inputVal.length > 0) {
        this.$emit('input:value-parsed', false)
        this.$emit('input:isvalid', false)
        if (alert && this.inputVal) {
          this.alert(this.data.Text + ' is invalid')
        }
      }

/*
      const parsedValue = PreApproveMe.parseInputValue(this.inputData)
      this.$emit('input:value-parsed', parsedValue)
      if (parsedValue !== false) {
        this.$emit('input:isvalid', true)
        this.$emit('input', parsedValue)
      } else {
        this.$emit('input:isvalid', false)
        if (alert && this.inputVal) {
          this.alert(this.data.Text + ' is invalid')
        }
      }
*/
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    onKeyDown: function(evt) {
      const currValue = this.inputVal
      if (evt.key == 'Backspace') {
        if (currValue.length > 1) {
          const lastChar = currValue[currValue.length - 1]
          if (lastChar == '/') this.$emit('input', currValue.slice(0, -1))
        }
      }
    },
    onType: function(evt) {
      var raw = this.inputVal || ''
      var parts = ['', '', '', '']
      var parsed = null

      for (var i = 0; i < raw.length; i++) {
        parsed = parseInt(raw.charAt(i))

        if (isNaN(parsed))
          continue

        for (var j = 0; j < parts.length; j++)
          if (parts[j].length < 2) {
            parts[j] = parts[j] + parsed
            break
          }
      }

      var formatted = parts[0]
      if (parts[0].length == 2)
        formatted = formatted + '/' + parts[1]
      if (parts[1].length == 2)
        formatted = formatted + '/' + parts[2] + parts[3]

      if (raw !== formatted)
        this.inputVal = formatted
    },
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.validate()
      this.isFocused = false
      this.$emit('input:isfocused', false)
    }
  },
  created: function() {
    if (this.data.Type) this.inputData.type = this.data.Type
    else this.inputData.type = PreApproveMe.getInputType('Date')
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required
    
    // Validate if pre-filled
    if (this.value) {
      this.validate()
    }

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
  },
  watch: {
    inputVal: function(value) {
      this.$emit('input:change', value)
      this.validate()
    }
  }
}
</script>

<style scoped lang="scss">
input.input-date {
}
</style>
